module.exports = __webpack_public_path__ + "img/order-details-cropped.65cfa4bd.jpg";